export default {"src":"/hedera/_next/static/media/halborn.26954b1e.svg","height":25,"width":36};